import { combineReducers } from "redux";
import userReducer from "./userReducer";
import networkReducer from "./networkReducer";
import restaurantReducer from "./restaurantReducer";
import connectionReducer from "./connectionReducer";
import globalParamReducer from "./globalParamReducer";
import authReducer from "./authReducer";
import paymentReducer from "./paymentReducer";
import p24TransactionReducer from "./p24TransactionReducer";
import p24TransactionLogReducer from "./p24TransactionLogReducer";
import p24RestaurantChequeTransactionReducer from "./p24RestaurantChequeTransactionReducer";
import p24RestaurantLogReducer from "./p24RestaurantLogReducer";
import p24RestaurantMerchantReducer from "./p24RestaurantMerchantReducer";
import p24MerchantReducer from "./p24MerchantReducer";
import p24LogReducer from "./p24LogReducer";
import flow24ServerReducer from "./flow24ServerReducer";

export default combineReducers({
  userReducer: userReducer,
  networkReducer: networkReducer,
  restaurantReducer: restaurantReducer,
  connectionReducer: connectionReducer,
  globalParamReducer: globalParamReducer,
  authReducer: authReducer,
  paymentReducer: paymentReducer,
  p24TransactionReducer: p24TransactionReducer,
  p24TransactionLogReducer: p24TransactionLogReducer,
  p24RestaurantChequeTransactionReducer: p24RestaurantChequeTransactionReducer,
  p24RestaurantLogReducer: p24RestaurantLogReducer,
  p24RestaurantMerchantReducer: p24RestaurantMerchantReducer,
  p24MerchantReducer: p24MerchantReducer,
  p24LogReducer: p24LogReducer,
  flow24ServerReducer: flow24ServerReducer
});
